// imports section Start
import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import { AppBar, Box, Breadcrumbs, Grid } from "@mui/material";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import OfficerOrders from "../../components/officer/OfficerOrders";
import OfficerManageOrders from "../../components/officer/OfficerManageOrders";
import OfficerTotalOrders from "../../components/officer/OfficerTotalOrders";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Link from "@mui/material/Link";
// imports section End

export default function Officer() {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  // State for managing selected order
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [componentVisibility, setComponentVisibility] = useState(false);
  // Hooks end

  // Handlers start
  const handleSelectOrder = (order) => {
    setComponentVisibility(true);
    setSelectedOrder(order); // Update selected order
  };
  // Handlers end

  return (
    <>
      {" "}
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Officer</Link>
                {/* <Link underline="none">View Categories</Link> */}
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.officer_AddStyledBox}>
        <Grid container spacing={2}>
          {/* Manage Orders Component */}
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            {/* <Box> */}
            <OfficerOrders onSelectOrder={handleSelectOrder} />
            {/* </Box> */}
            {/* <Box mt={6}>
              <OfficerTotalOrders />
            </Box> */}
          </Grid>

          {/* Manage Orders Component */}
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <OfficerManageOrders
              orderDetails={selectedOrder}
              componentVisibility={componentVisibility}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
